import { ObjectType } from 'interfaces';

interface CategorizationArgs {
  baseCategory?: string | null;
  refSource?: string | null;
  refType?: ObjectType | string | null;
  part?: {
    partType?: string | null;
  } | null;
}

/**
 * Determines accounting category for an incoming invoice position based on business rules.
 * - If refSource contains 'PO-' and refType === 'Deal::Lot' and part is a mold (partType === 'mold'),
 *   returns 'im_tools'.
 * - Otherwise returns the provided base category to avoid misclassifying non-mold PO lots.
 */

export function determineAccountingCategory({ baseCategory, refSource, refType, part }: CategorizationArgs): string {
  const ref = String(refSource || '');

  if (ref.includes('PO-') && refType === ObjectType.DealLot && part?.partType === 'mold') {
    return 'im_tools';
  }

  return baseCategory ?? '';
}
